function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "0%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#183A9E",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0F256E",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M123.76 2.24L2.24 123.76a6 6 0 0 0 0 8.48l121.52 121.52a6 6 0 0 0 8.48 0l121.52-121.52a6 6 0 0 0 0-8.48L132.24 2.24a6 6 0 0 0-8.48 0z",
  fill: "url(#a)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.76 2.24L2.24 123.76a6 6 0 0 0 0 8.48l121.52 121.52a6 6 0 0 0 8.48 0l121.52-121.52a6 6 0 0 0 0-8.48L132.24 2.24a6 6 0 0 0-8.48 0z",
  fill: "url(#a)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179 94.28l-19.65-19.67c-6.49 6.5-12.31 13.5-17.46 20.88V60h-27.78v35.5a154.56 154.56 0 0 0-17.46-20.9L77 94.29a124.3 124.3 0 0 1 36.08 77H86.33L128 213l41.67-41.73h-26.75A124.3 124.3 0 0 1 179 94.28",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.24 15.88L15.88 125.24a3.9 3.9 0 0 0 0 5.52l109.36 109.36a3.9 3.9 0 0 0 5.52 0l109.36-109.36a3.9 3.9 0 0 0 0-5.52L130.76 15.88a3.9 3.9 0 0 0-5.52 0z",
  stroke: "#FFF",
  strokeWidth: 3
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.f8f8fc39.svg";
export { ForwardRef as ReactComponent };